import { useRef, useState } from "react";
import QrScanner from "qr-scanner";
import localForage from "localforage";
import { FREYA_DEVICE_ID_KEY } from "./FreyaPrintSettings";
import { Nullable } from "../../../common/types";


interface QrScannerRef {
  scanner: Nullable<QrScanner>;
}

export const useInitCameraDevices = (useIndexDB = false) => {
  const qrScanner = useRef<QrScannerRef>({ scanner: null });
  const [selectedCameraDevice, setSelectedCameraDevice] = useState<QrScanner.Camera>();
  const [cameraDevices, setCameraDevices] = useState<Array<QrScanner.Camera>>([]);
  const [deviceIdFormIndexDB, setDeviceIdFromIndexDB] = useState('');
  const [localStream, setLocalStream] = useState<Nullable<MediaStream>>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const getDevices = async () => {
    return await QrScanner.listCameras();
  };

  const setCamera = async (camera: QrScanner.Camera) => {
    if (!camera) return;
    setSelectedCameraDevice(camera);
  };


  const initCameraDevices = async (key?: string) => {
    const devices = await getDevices();
    setCameraDevices(devices);
    const deviceId = await localForage.getItem(key || FREYA_DEVICE_ID_KEY) as string;
    const device = useIndexDB && deviceId? devices.find(device => device.id === deviceId) : devices[0];
    setDeviceIdFromIndexDB(deviceId);
    await setCamera(device!);
    return device;
  };

  const initDevices = async (key?: string) => {
    try {
      await initCameraDevices(key);
    } catch(e) {
      setError(true);
    }
    setLoading(false);
  }

  const cameraPermissionRequest = async () => {
    await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
      .then(response => {
        setLocalStream(response);
      })
      .then(() => {
        localStream?.getTracks().forEach(track => {
          track.stop();
        });
      })
      .catch(error => console.log(error));
  };

  return {
    cameraDevices,
    selectedCameraDevice,
    setSelectedCameraDevice,
    cameraPermissionRequest,
    localStream,
    setLocalStream,
    qrScanner,
    loading,
    error,
    setCamera,
    initCameraDevices,
    initDevices,
    deviceIdFormIndexDB
  };
}